import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=3ca5362b&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./css/Detail.scss?vue&type=style&index=0&id=3ca5362b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca5362b",
  null
  
)

export default component.exports